/**
 * Path to the single-title page for a catalog asset id (slug).
 */
export function titleDetailPath(titleId: string): string {
  return `/home/title/${encodeURIComponent(titleId)}`;
}
